import type { CSSProperties } from 'react';
import type { ButtonTone } from '@/components/Button';
import type { DialogVariant } from './types';
import { DANGER } from './constants';

export const classes = {
  paper: 'w-[420px] max-w-[calc(100vw-24px)]',
  body: 'flex flex-col pt-6',
  header: 'flex flex-col items-center gap-[13px] text-center',
  textBlock: 'min-w-0',
  badge: 'place-center size-[46px] shrink-0 rounded-[15px]',
  title:
    'mb-1.5 text-[18px] font-extrabold leading-tight tracking-[-0.01em] text-taupe-3 dark:text-mauve-1',
  message: 'text-[13.5px] leading-[1.55] text-taupe-2 dark:text-mauve-2',
  actions: 'mt-7',
};

export const styles = {
  badge: (accent: string): CSSProperties => ({
    backgroundColor: `${accent}21`,
    color: accent,
  }),
};

export function resolveAccent(variant: DialogVariant, destructive: boolean) {
  if (destructive) return DANGER;
  const accents: Record<DialogVariant, string> = {
    info: '#3b6fe0',
    success: '#16a34a',
    warning: '#f59e0b',
    error: DANGER,
    confirm: '#f15a2b',
  };
  return accents[variant];
}

export function resolveTone(
  variant: DialogVariant,
  destructive: boolean
): ButtonTone {
  if (destructive) return 'danger';
  const tones: Record<DialogVariant, ButtonTone> = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'danger',
    confirm: 'brand',
  };
  return tones[variant];
}
